
import { Component, Vue, Prop, Emit } from "vue-property-decorator";
import SidebarPlanListItem from "./SideBarPlanListItem.vue";
import { LotCountNeighborhood, SidebarHomePlan } from "./../types";
@Component({
  components: {
    SidebarPlanListItem,
  },
})
export default class SidebarPlanList extends Vue {
  @Prop() private selectedJobNum!: string
  @Prop() private qmiAndHomeplans!: any[];
  @Prop() private selectedHomePlanIds!: string[];
  @Prop() private selectedLotId!: string;
  @Prop() private selectedHomePlanId!: string;
  @Prop() private selectedLotStatus!: string;
  @Prop() availableLots!: number;
  @Prop() private isKioskMode!: boolean;
  @Prop() neighborhoodId!: string;
  @Prop() listPlanId!:string[];
  @Prop() listHomeType!:string[];
  @Prop() selectedNeighborhoodIds!: string[];
  @Prop() initialHomePlanCount!: number;
  @Prop() private lotsCount!: LotCountNeighborhood[];
  @Emit("setHomePlanId") setHomePlanId(planId: string) {}
  @Emit("CleanHomeId")CleanHomeId(){}
  @Emit("toggleshowFilters")toggleshowFilters(){}
}
